import R from "core/resources";
import p1 from "res/gfx/p1_spritesheet.json";
import p2 from "res/gfx/p2_spritesheet.json";
import p3 from "res/gfx/p3_spritesheet.json";
const players = [p1, p2, p3];
export default function PlayerIcon(playerName, iconName) {
  if (!(playerName in R.gfx)) throw `No graphics for player ${playerName}`;
  const gfx = R.gfx[playerName];
  const {
    sprite
  } = gfx.getSprite(iconName);
  if (!sprite) throw `No sprite for ${playername}.${iconName}!`;
  const {
    width,
    height,
    canvas
  } = sprite;
  const dataURL = canvas.toDataURL();
  const element = document.createElement("div");
  element.classList.add("frame");
  element.style.backgroundImage = `url("${dataURL}")`;
  element.style.width = `${width}px`;
  element.style.height = `${height}px`;
  element.sprite = sprite;
  return element;
}